<template>
  <router-link :class="['course-tile', customClass]" :to="link">
    <div
      class="course-tile__background"
      :style="
        `background-image: url(${backgroundImg}), linear-gradient(${gradient})`
      "
    >
      <div class="course-tile__overlay"></div>
      <div class="course-tile__details">
        <div
          v-if="course.has_sample_content && isFreeTrialUser"
          class="course-tile__snipe"
        >
          Included
        </div>
        <div v-if="course.status === 'coming soon'" class="course-tile__snipe">
          Coming Soon
        </div>
        <div
          class="course-tile__title"
          v-tooltip="{
            content: course.name.length >= maxLength ? course.name : '',
          }"
        >
          {{ truncateTitle(course.name) }}
        </div>
        <div class="course-tile__instructor">
          <div>
            <p class="course-tile__instructor-lead">Instructor</p>
            <p
              v-if="course.instructors && course.instructors[0]"
              class="course-tile__name"
            >
              {{ course.instructors[0].name }}
            </p>
          </div>
          <div v-if="learningAreaName" class="course-tile__branding">
            {{ learningAreaName }}
          </div>
        </div>
      </div>
      <div class="course-tile__extended-details">
        <div class="course-tile__duration-wrapper">
          <p class="lead">duration</p>
          <p class="data">{{ duration }}</p>
        </div>
        <div class="course-tile__difficulty-wrapper">
          <p class="lead">difficulty</p>
          <p class="data">
            <span class="course-tile__difficulty-component">
              <Difficulty :difficulty="course.difficulty || ''" />
            </span>
          </p>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { truncateText } from '@/helpers'
import Difficulty from '@/components/properties/Difficulty.vue'

export default {
  name: 'CourseTile',
  components: {
    Difficulty,
  },
  data() {
    return {
      maxLength: 80,
    }
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
    backgroundImg: {
      type: String,
      required: true,
    },
    gradient: {
      type: String,
      required: true,
    },
    duration: {
      type: String,
      required: true,
    },
    learningAreaName: {
      type: String,
      required: false,
    },
    link: {
      type: Object,
      required: true,
    },
    customClass: {
      type: String,
      required: false,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    truncateTitle(value) {
      return truncateText(value, this.maxLength)
    },
  },
}
</script>

<style lang="scss">
.course-tile {
  height: 300px;
  min-height: 300px;
  min-width: 350px;
  text-align: left;
  background: var(--light-gray);
  color: var(--white);
  margin: 0 0 10px 0;
  text-decoration: none;
  padding: 5px;
  &:hover {
    cursor: pointer;
    .course-tile__overlay {
      opacity: 1;
    }
  }
  &__background {
    min-height: 225px;
    height: 225px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    z-index: 1;
  }
  &__overlay {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    right: 0;
    top: 0;
    z-index: -1;
    opacity: 0;
    transition: 0.5s all ease;
  }
  &__details {
    width: 100%;
    padding: 30px 25px 15px 30px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
    position: relative;
  }
  &__snipe {
    position: absolute;
    top: 0;
    right: 0;
    background: var(--black);
    color: var(--white);
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 700;
    padding: 7px 10px;
  }
  &__title {
    font-size: 1.2rem;
    font-weight: 700;
    width: 220px;
    color: var(--white);
  }
  &__instructor {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  &__instructor-lead {
    color: lightgray;
    text-transform: uppercase;
    margin: 0;
    font-size: 0.8rem;
    font-weight: 700;
  }
  &__name {
    color: var(--white);
    font-weight: 700;
    margin: 0;
  }

  &__branding {
    font-weight: 700;
    font-size: 0.8rem;
    text-transform: uppercase;
    justify-self: flex-end;
    color: var(--white);
  }
  &__extended-details {
    display: flex;
    margin: 10px 0 0 0;
    padding: 0 20px;
    position: relative;
  }
  &__duration-wrapper {
    margin: 0 50px 0 0;
  }
  .lead {
    font-size: 0.8rem;
  }
}
</style>
